/**
 * Applies a click on an option to the current selection.
 *
 * Single-select holds at most one id and clears it when the selected option is
 * clicked again, mirroring how the select inputs let a choice be undone.
 * Multiselect adds or removes the id while preserving the order options were
 * picked in.
 */
export const toggleOptionSelection = (
  selectedIds: string[],
  id: string,
  isMultiselect: boolean
): string[] => {
  const isSelected = selectedIds.includes(id);

  if (!isMultiselect) {
    return isSelected ? [] : [id];
  }

  return isSelected
    ? selectedIds.filter((selectedId) => selectedId !== id)
    : [...selectedIds, id];
};
